import type { Offer as OfferContract } from '@luxuryescapes/contract-svc-offer';

export type TransferDetails = OfferContract.TransferDetails;

export function toTransferDetailsFormValue(value?: TransferDetails | null) {
  return {
    heading: value?.heading ?? '',
    body: value?.body ?? '',
  };
}

export function serializeTransferDetails(value?: { heading?: string; body?: string } | null): TransferDetails | null {
  const heading = value?.heading?.trim() ?? '';
  const body = value?.body?.trim() ?? '';

  if (!heading && !body) {
    return null;
  }

  return { heading, body };
}

export function areTransferDetailsEqual(
  left?: { heading?: string; body?: string } | null,
  right?: { heading?: string; body?: string } | null,
) {
  return JSON.stringify(serializeTransferDetails(left)) === JSON.stringify(serializeTransferDetails(right));
}
